// extracted by mini-css-extract-plugin
export var content = "_ap-3";
export var list = "_ap-4";
export var settingsContent = "_ap-7";
export var settingsPanel = "_ap-8";
export var state = "_ap-6";
export var triggerBadge = "_ap-2";
export var triggerButton = "_ap-1";
export var triggerShell = "_ap-0";
export var unreadDot = "_ap-5";